export default "__VITE_ASSET__b6b5aead__"